import React, { memo, useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getVenueDetails } from "store/slice/profile";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { IoIosArrowDown } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import Button from "component/ui/Button";
import CancelSlotsDialog from "./cancelSlotsDialog";
import { useNavigate } from "react-router-dom";

const BookingDetailsDialog = ({
  closeDialog,
  open,
  data,
  fetchBookingHistory,
}) => {
  const dispatch = useDispatch();
  const { venueDetailsData, userProfileData } = useSelector(
    (state) => state.profile
  );
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [actionType, setActionType] = useState("");
  const navigate = useNavigate();

  const detailsData = [
    {
      id: "spotsName",
      Label: "Sports Name",
      value: data?.venueCardData[0] && data?.venueCardData[0]?.sportsName,
    },
    {
      id: "referenceId",
      Label: "Reference Id",
      value:
        data?.venueCardData?.length > 0 &&
        data?.venueCardData[0]?.cardReferenceID,
    },
    {
      id: "bookedFor",
      Label: "Booked For",
      type: "date",
      value: data?.venueCardData[0] && data?.venueCardData[0]?.bookingDate,
    },
    {
      id: "bookedOn",
      Label: "Booked On",
      type: "date",
      value: data?.createdDateTime,
    },
    {
      id: "amountPaid",
      Label: "Amount Paid",
      value: `₹${data?.totalAmount}`,
    },
    {
      id: "location",
      Label: "Location",
      value:
        data?.venueCardData[0] &&
        data?.venueCardData[0]?.venueLocation?.address,
    },
    {
      id: "playersNo",
      Label: "No Of Players Attending",
      value: venueDetailsData?.noOfPlayreAttanding,
    },
  ];

  useEffect(() => {
    if (data?.venueCardData[0]) {
      dispatch(getVenueDetails(data?.venueCardData[0]?.venueCardId));
    }
  }, [data]);

  return (
    <>
      {open && (
        <div
          onClick={closeDialog}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/65 backdrop-blur-lg animate-fadeIn"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="container m-auto w-full h-full overflow-hidden bg-white shadow-2xl animate-slideUp font-poppins "
          >
            {/* Header */}
            <div className="relative overflow-hidden bg-gradient-to-br from-[#2bace2] to-[#1a8fc9] px-5 py-3 max-sm:px-6 max-sm:py-5">
              <div className="relative z-10 flex items-center justify-between">
                <h2 className="text-white text-2xl font-semibold">
                  Order Details
                </h2>
                <button
                  onClick={closeDialog}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white text-xl transition-all hover:bg-white/30 hover:rotate-90"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-8 overflow-y-auto max-h-[calc(90vh-100px)] max-sm:p-6">
              {/* Buyer */}
              <div className="mb-7 pb-5 border-b-2 text-[22px] font-semibold text-slate-900 font-outfit">
                {data?.buyerName}
              </div>

              {/* Details */}
              {detailsData?.map((item, index) => (
                <div
                  key={index}
                  className="group flex justify-between gap-4 py-4 border-b transition-all hover:bg-slate-50"
                >
                  <span className="text-sm font-medium text-slate-500">
                    {item?.Label}:
                  </span>
                  <span className="text-sm font-medium text-slate-800 text-right break-words">
                    {item?.type === "date"
                      ? moment(item?.value).format("DD/MM/YYYY")
                      : item?.value}
                  </span>
                </div>
              ))}

              {/* Assigned Users */}
              <div className="mt-8 mb-5 flex items-center text-lg font-semibold text-slate-900 font-outfit">
                <span className="mr-3 h-5 w-1 rounded bg-gradient-to-b from-[#2bace2] to-[#1a8fc9]" />
                Assigned Users
              </div>

              <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-4 max-sm:grid-cols-[repeat(auto-fill,minmax(140px,1fr))]">
                {venueDetailsData?.joinPlayersData?.map((item, index) => (
                  <div
                    key={index}
                    className="relative flex flex-col items-center gap-2 rounded-xl border-2 border-slate-200 bg-gradient-to-br from-slate-50 to-slate-100 p-4 transition-all hover:border-[#2bace2] hover:shadow-lg"
                  >
                    {item?.profileImageUrl ? (
                      <img
                        src={item?.profileImageUrl}
                        alt={item?.name}
                        className="h-14 w-14 rounded-full border-4 border-white object-cover shadow-md"
                      />
                    ) : (
                      <div className="h-14 w-14 rounded-full bg-gradient-to-br from-[#2bace2] to-[#1a8fc9] flex items-center justify-center text-white text-xl font-semibold shadow-md capitalize">
                        {item?.name?.[0]}
                      </div>
                    )}

                    <span className="text-sm font-medium text-slate-700 text-center">
                      {item?.name}
                    </span>

                    {item?.id === userProfileData?.data?.id ? (
                      <span className="rounded-full bg-brand-gradient px-3 py-1 text-[10px] font-semibold text-white">
                        You
                      </span>
                    ) : (
                      <CgProfile
                        onClick={() => navigate(`/player-details/${item?.id}`)}
                        className="h-8 w-8 text-[#2bace2] cursor-pointer transition hover:scale-110 hover:text-[#1a8fc9]"
                      />
                    )}
                  </div>
                ))}
              </div>

              {/* Booked Slots */}
              {data?.venueCardData?.[0]?.slotDetails?.length > 0 && (
                <>
                  <div className="mt-10 mb-5 flex items-center text-lg font-semibold text-slate-900 font-outfit">
                    <span className="mr-3 h-5 w-1 rounded bg-gradient-to-b from-[#2bace2] to-[#1a8fc9]" />
                    Booked Slots
                  </div>

                  <Accordion allowZeroExpanded className="border-none">
                    {data.venueCardData[0].slotDetails.map((item, index) => (
                      <AccordionItem
                        key={index}
                        className="mb-3 overflow-hidden rounded-xl border-2 border-slate-200 bg-white transition hover:shadow-sm"
                      >
                        <AccordionItemHeading>
                          <AccordionItemButton className="flex items-center justify-between p-3 bg-gradient-to-br from-slate-50 to-slate-100 hover:from-slate-100 hover:to-slate-200 transition">
                            <span className="font-semibold text-slate-700 capitalize">
                              {item?.courtName}
                            </span>
                            <IoIosArrowDown className="text-xl text-[#2bace2] transition-transform" />
                          </AccordionItemButton>
                        </AccordionItemHeading>

                        <AccordionItemPanel className="p-5 animate-slideDown">
                          <div className="mb-4 rounded-lg border-l-4 border-amber-500 bg-gradient-to-br from-amber-100 to-amber-200 px-4 py-3 text-sm font-medium text-amber-800">
                            {data?.venueCardData[0]?.slotRescheduleFlag
                              ? `Reschedule/Cancellation window : ${item?.rescheduleCancelFrequency} hour before start`
                              : "Reschedule/Cancellation window is closed"}
                          </div>

                          <div className="grid grid-cols-[repeat(auto-fill,minmax(130px,1fr))] gap-3">
                            {item?.slots?.map((time, i) => (
                              <div
                                key={i}
                                className="rounded-lg border-1 border-gray-200 px-4 text-center text-sm font-semibold text-gray-600 transition py-3 bg-gray-200 text-black cursor-not-allowed"
                              >
                                {time.fromTime}-{time.toTime}
                              </div>
                            ))}
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>
                    ))}
                  </Accordion>

                  {!data?.isBookingCompleted &&
                    data?.venueCardData[0]?.slotDetails[0]?.slots.some(
                      (s) => s.venueWindowOpen
                    ) && (
                      <div className="mt-5 grid grid-cols-2 gap-3 max-sm:grid-cols-1">
                        <Button
                          fullWidth
                          onClick={() => {
                            setActionType("Cancel");
                            setShowCancelDialog(true);
                          }}
                        >
                          Cancel Slots
                        </Button>
                        <Button
                          fullWidth
                          onClick={() => {
                            setActionType("Reschedule");
                            setShowCancelDialog(true);
                          }}
                        >
                          Reschedule Slots
                        </Button>
                      </div>
                    )}
                </>
              )}
            </div>
          </div>

          {/* Cancel Dialog */}
          {showCancelDialog && (
            <CancelSlotsDialog
              orderData={data}
              closeCancelSlotDialog={() => setShowCancelDialog(false)}
              actionType={actionType}
              fetchListing={fetchBookingHistory}
              closeDialog={() => setShowCancelDialog(false)}
              slotsData={data?.venueCardData?.[0]?.slotDetails || []}
            />
          )}
        </div>
      )}
    </>
  );
};

export default memo(BookingDetailsDialog);
